module.exports = __webpack_public_path__ + "img/5.ff508225.webp";